import { z } from 'zod';

import { PrincipalModificationId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const ReversePrincipalModificationEvent = BaseLoanEvent.extend({
  type: z.literal('reversePrincipalModification'),
  principalModificationId: PrincipalModificationId,
});

export type ReversePrincipalModificationEvent = z.infer<typeof ReversePrincipalModificationEvent>;
